import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { OperationEntityConfigurationTableContent } from '../../Common/Table/tableContent';
import services from '../services';
import TextField from '@material-ui/core/TextField';
import $ from 'jquery';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { search } from '../../Common';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { Category } from '@material-ui/icons';
import { operationEntityConfigurationSchema } from '../../Data/Validation/operationEntityConfigurationSchema';

const screenCode = 'OPERATIONENTITYCONFIGURATION'

export function OperationEntityConfiguration(props) {

    const [allOperationEntityConfiguration, setAllOperationEntityConfiguration] = useState([])
    const [pageSize, setPageSize] = useState(4)
    const [currentPage, setCurrentPage] = useState(1);
    const [groups, setGroups] = useState();
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [searchForm, setSearchForm] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0
    });
    const [operationEntityConfigurations, setOperationEntityConfigurations] = useState();
    const contentRowNames = ["operationEntityName", "collectionPointName", "configName", "configurationType", "minValue"
        , "maxValue", "configurationValue", "isApply", "isActive","jsonString"]
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isTableHidden, setIsTableHidden] = useState(true);
    const schema = Joi.object(operationEntityConfigurationSchema).options({ allowUnknown: true })

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            OperationEntityConfigurationByGroupEntity()
        )
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown(),
            handleSearch()
        )
    }, [searchForm.operationEntityID]);

    useEffect(() => {
        trackPromise(
            handleSearch(),
        )
    }, [searchForm.collectionPointID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWOPERATIONENTITYCONFIGURATION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITOPERATIONENTITYCONFIGURATION');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()

        setGroups(result)
    }

    async function getAllOperationEntityConfiguration(groupID, operationEntityID, collectionPointID) {
        const data = await services.getOperationEntityConfiguration(groupID, operationEntityID, collectionPointID);
        return data;
    }

    function destroyDataTable() {
        setIsTableHidden(true);
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
        setIsTableHidden(false);
    }


    function handleClick(item) {

        props.history.push({
            pathname: 'operationEntityconfiguration/addEdit',
            data: item,
            edit: true
        })
    }

    function handlePageChange(page) {
        setCurrentPage(page)
    }

    function handleGroupChange(e) {

        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, operationEntityConfigurationSchema)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value,

        });
        trackPromise(
            OperationEntityConfigurationByGroupEntity(value))
        setErrors(error)
    }

    async function OperationEntityConfigurationByGroupEntity() {
        let filteredData = await services.getOperationalEntityByGroupEntityID(searchForm.groupID);
        setOperationEntityConfigurations(filteredData)
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await services.getCollectionPointsByOperationentityGroupID(searchForm.operationEntityID, searchForm.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleOperationEntityChange(e) {

        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, operationEntityConfigurationSchema)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value,
        })
        setErrors(error);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        })
    }


    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    async function handleSearch(e) {
        if (e !== undefined) {
            const errorMessages = validate(schema, searchForm);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }
        if (searchForm.groupID !== 0 && searchForm.operationEntityID !== 0) {
            destroyDataTable();
            var operationEntityConfiguration = await getAllOperationEntityConfiguration(searchForm.groupID, searchForm.operationEntityID, searchForm.collectionPointID);
            operationEntityConfiguration.forEach(x => {
                x.configurationTypeID = x.configurationType;
                if (x.configurationType === 1) {
                    x.configurationType = "Value";
                }
                else if (x.configurationType === 2) {
                    x.configurationType = "Min Max";
                }
                else if (x.configurationType === 3) {
                    x.configurationType = "Boolean";
                }
            });
            setAllOperationEntityConfiguration(operationEntityConfiguration);
            createDataTable();
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Operation Entity Configuration"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Operation Entity Configuration"
                            path="operationEntityConfiguration/addEdit" />
                        <div className="card-body">
                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={searchForm.groupID}
                                            onChange={(e) => handleGroupChange(e)}>
                                            <MenuItem value="0">--Select Group Name--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={searchForm.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntityConfigurations)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection Point</InputLabel>
                                        <Select fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={searchForm.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                    </div>
                                </div>
                            </form>
                            {allOperationEntityConfiguration.length > 0 ?
                            <div className="table-responsive row-top-gap">
                                <table id="example" hidden={isTableHidden} className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Operation Entity</th>
                                            <th>Collection Point</th>
                                            <th>Name</th>
                                            <th>Type</th>
                                            <th>MinValue</th>
                                            <th>MaxValue</th>
                                            <th>Value</th>
                                            <th>Is Apply</th>
                                            <th>Status </th>
                                            <th>Json String</th>
                                            

                                            {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <OperationEntityConfigurationTableContent
                                            data={allOperationEntityConfiguration}
                                            contentRowNames={contentRowNames}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            handleClick={handleClick}
                                        />
                                    </tbody>
                                </table>
                            </div> : null}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )

}